<template>
    <v-card flat>
        <v-card-text>
            <v-container>
                <v-row v-if="selectedItem == null">
                    <v-col cols="12" sm="12" md="12">
                        <v-spacer class="text-center">
                        Não há dados financeiros cadastrados para este usuário
                        </v-spacer>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col cols="12" sm="12" md="12">
                        <v-text-field
                            :value="selectedItem.annual_income | formatDecimal"
                            label="Renda Anual"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <v-text-field
                            :value="selectedItem.net_worth | formatDecimal"
                            label="Patrimônio Líquido"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>


<script>
export default {
  name: 'Income',
  props: {
    selectedItem: {
        type: Object,
        required: false,
    },
  },
}
</script>
